import React from "react";

// Small root-category tag (e.g. [Tanya], [Q&A]) shown next to a result title.
// Renders nothing when the section is unresolved/absent.
export default function SectionChip({ section }) {
  if (!section) return null;
  return (
    <span className="shrink-0 rounded bg-[#D2D6DC] bg-opacity-60 text-primaryDark text-xs px-2 py-0.5">
      {section}
    </span>
  );
}
